'use client';
import { createTheme } from '@mui/material/styles';
import { basicThemeV6 } from './basic-theme-v6';
import { typographySmall } from './components/typography';
import { spacingSmall } from './components/spacing';
import { deepmerge } from '@mui/utils';
export const staffCompact = createTheme(deepmerge(basicThemeV6, {
    typography: typographySmall,
    spacing: spacingSmall
}));
export default staffCompact;
